export default ({ report, stats, highlights, homeTeamData, guestTeamData }) => (`
  <div class="stat-info">
      <div class="stat-info__score d-flex align-items-center justify-content-center" style="padding-bottom: 15px;">
          <div class="stat-info__score-team d-flex flex-column"><div class="stat-info__logo"><img class="match-info__logo-image" src="/assets/images/logo2.svg" alt="" /></div> ${homeTeamData.team.name}</div>
          <div class="stat-info__score-result text-center d-flex align-items-center justify-content-center">Team Stats</div>
          <div class="stat-info__score-team d-flex flex-column"><div class="stat-info__logo"><img class="match-info__logo-image" src="/assets/images/logo4.svg" alt="" /></div> ${guestTeamData?.team?.name || '...'}</div>
      </div>
  </div>
  ${(Object.keys(stats))?.map((item) => `
    <div class="stat-item d-flex align-items-center justify-content-center">
        <div class="col stat-item__value text-center">${stats[item][1]||0}</div>
        <div class="col stat-item__title text-center" style=" text-transform: capitalize">${item.replace('_', ' ').replace('_', ' ').toLowerCase()}</div>
        <div class="col stat-item__value text-center">${stats[item][2]||0}</div>
    </div>
  `).join('')}
`);
